import { j as o } from "../jsx-runtime.BREq8dyb.js";
import { faXmark as j } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as h } from "@fortawesome/react-fontawesome";
import { Chip as u, Tooltip as g, ChipDelete as p, Stack as x } from "@mui/joy";
const y = (e) => Object.entries(e).reduce((t, [s, r]) => {
  if (Number.isInteger(parseInt(s, 10))) {
    const {
      message: n
    } = r;
    n && (t[n] = [...t[n] || [], parseInt(s, 10)]);
  }
  return t;
}, {}), A = (e, t, {
  lockedValues: s = []
} = {}) => {
  const r = Object.entries(y(t)).map(([i, a], l) => {
    const c = `${i} – ${a.length}`;
    return e.value.some((m) => !s.includes(m)) ? /* @__PURE__ */ o.jsx(u, { color: "danger", endDecorator: /* @__PURE__ */ o.jsx(g, { size: "sm", title: "Remove emails", children: /* @__PURE__ */ o.jsx(p, { onClick: () => {
      e.onChange(e.value.filter((m, f) => s.includes(m) || a.indexOf(f) === -1));
    }, children: /* @__PURE__ */ o.jsx(h, { icon: j }) }) }), size: "sm", variant: "plain", children: c }, l) : c;
  });
  let n = t?.root?.message || null;
  switch (t?.root?.type) {
    case "too_big": {
      const {
        maximum: i
      } = t.root;
      i && (n = /* @__PURE__ */ o.jsx(u, { color: "danger", endDecorator: /* @__PURE__ */ o.jsx(g, { size: "sm", title: "Remove emails", children: /* @__PURE__ */ o.jsx(p, { onClick: () => {
        e.onChange(e.value.slice(0, Number(i)));
      } }) }), size: "sm", variant: "plain", children: t?.root?.message }));
      break;
    }
  }
  return t?.message || /* @__PURE__ */ o.jsxs(x, { direction: "row", spacing: 1, children: [
    r,
    n
  ] });
}, D = (e) => {
  const {
    timeout: t,
    style: s = {},
    mode: r
  } = e;
  return {
    delay: s.transitionDelay,
    duration: typeof t == "object" ? t[r] || 0 : t,
    easing: s.transitionTimingFunction
  };
}, T = (e) => {
  e.scrollTop = e.scrollTop;
}, b = {
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)"
}, d = (e) => `${Math.round(e)}ms`;
function z(e = ["all"], t) {
  const {
    duration: s = 300,
    easing: r = b.easeInOut,
    delay: n = 0
  } = t || {};
  return (Array.isArray(e) ? e : [e]).map((a) => {
    const l = typeof s == "string" ? s : d(s), c = typeof n == "string" ? n : d(n);
    return `${a} ${l} ${r} ${c}`;
  }).join(",");
}
export {
  A as createErrorMessagesAndAutofixes,
  z as createTransition,
  D as getTransitionProps,
  y as groupNestedErrorsIndexesByMessage,
  T as reflow
};
//# sourceMappingURL=index.js.map
